module.exports = __webpack_public_path__ + "static/media/logos_igtv_1080x1920.64ff8257.png";